import React from "react";
import WhatwedoBglanding from "./WhatwedoBglanding";
import WhatwedoHeading from "./WhatwedoHeading";
import { Box, Typography } from "@mui/material";
import WhatwedoContent from "./WhatwedoContent";
import { Helmet } from "react-helmet";

const Whatwedo5 = () => {
  return (
    <>
      <Helmet>
        <title>
          Inteliphyle | Diverse & Uber Senior 'Glo-cal' Consulting Expertise
        </title>
        <meta
          name="description"
          content="Drawing from diverse industry experience, we offer unmatched expertise in understanding and resolving maketing and business issues - be it branding, communication, innovation, GTM or digital."
        />
      </Helmet>
      <Box
        sx={{
          backgroundColor: "#ecebeb",
        }}
      >
        <WhatwedoBglanding />
        <WhatwedoHeading />
        <WhatwedoContent />
        <Typography
          sx={{
            textAlign: "left",
            color: "rgba(51, 51, 51, 1)",
            fontFamily: "Plus Jakarta Sans",
            padding: { xs: "1rem", sm: "0 0 1rem 4rem" },
          }}
        >
          Partner with Inteliphyle to leverage our globally diverse, expert
          consulting team for innovative solutions that drive your business
          forward.
        </Typography>
      </Box>
    </>
  );
};

export default Whatwedo5;
